import Button from "../../Atoms/Button/Button";
import InputIncrementDecrement from "../../Atoms/InputIncrementDecrement/InputIncrementDecrement";
import { Table } from 'antd'
import './CampaingAssignmentProfileOperatos.scss'

const columns = [
  {
    title: "Nombre y Apellido",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Rol",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    fixed: 'right',
  },
];

const CampaingAssignmentProfileOperatos = () => {

  const profileList = [
    {
      key: 1,
      name: 'Jose antonio martinez ',
      email: 'joseantoniomartinez@gmil.com ',
      role: 'Funcional.',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 2,
      name: 'Jose antonio martinez ',
      email: 'joseantoniomartinez@gmil.com ',
      role: 'Funcional.',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 3,
      name: 'Jose antonio martinez ',
      email: 'joseantoniomartinez@gmil.com ',
      role: 'Funcional.',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    }
  ]

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
  };
  
  return (
    <div className="box mt-30 s-pxy-20 m-pxy-50">
      <p className="source-24 mb-30">Asignación de perfil de operadores:</p>
      <div className="associate-profile-header">
        <div>
          <p className="source-16 sm-bold mb-10">
            Cantidad de agentes inteligentes
          </p>
          <p className="source-16">IA creada y administrada por Geniux.</p>
        </div>
        <div>
          <InputIncrementDecrement initialValue={25} />
        </div>
        <div className="associate-profile-header_button">
          <Button
            content="Calcular costo"
            type="primary"
            customClass="s-large m-auto"
          />
          <p className="source-16 sm-bold mt-15">0,50 USD$ / día.</p>
        </div>
      </div>
      <div className="table-container mt-30">
        <Table 
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }} 
        columns={columns} dataSource={profileList} pagination={false} />
      </div>

      <div className="associate-profile-header_buttons">
        <div className="header-buttons_one">
          <Button content="Gestionar campañas" type="primary outline" customClass="s-large m-auto" />
          <Button content="Guardar proceso" type="primary" customClass="s-large m-auto" />
        </div>
        <div className="header-buttons_two">
          <Button content="Guardar y lanzar campaña" type="primary"  customClass="s-large m-auto"/>
        </div>
      </div>
    </div>
  );
};

export default CampaingAssignmentProfileOperatos;
